import cx from 'classnames';
import store from '~/javascripts/store.js';
import { Component } from 'react';
import { observer } from 'mobx-react';

const PaymentRequestForm = observer(
  class PaymentRequestForm extends Component {
    constructor(props) {
      super(props);

      this.displayPaymentRequestButtonIfSupported();
    }

    initializePaymentRequest = () =>
      this.props.stripe.paymentRequest({
        country: store.donateForm.accountCountry,
        currency: store.donateForm.currencyName,
        total: {
          label: this.buttonText(),
          amount: Math.round(store.donateForm.amount * 100),
        },
        requestPayerName: true,
        requestPayerEmail: !store.donateForm.isUserLoggedIn,
      });

    displayPaymentRequestButtonIfSupported = () => {
      this.paymentRequest = this.initializePaymentRequest();

      this.paymentRequest.canMakePayment().then((result) => {
        store.donateForm.supportsPaymentRequestButton = !!result;
        if (result) store.donateForm.supportsApplePay = result.applePay;
      });
    };

    addPaymentRequestListeners = () => {
      this.paymentRequest.on('paymentmethod', (event) => {
        if (!store.donateForm.isUserLoggedIn)
          store.donateForm.email = event.payerEmail;
        store.donateForm.setNameAndSurnameFromPayerName(event.payerName);
        store.donateForm.formAction = this.props.formAction;

        if (store.donateForm.showAddressCollection) {
          store.donateForm.billingAddress =
            event.paymentMethod.billing_details.address.line1;
          store.donateForm.billingCity =
            event.paymentMethod.billing_details.address.city;
          store.donateForm.billingZipcode =
            event.paymentMethod.billing_details.address.postal_code;
          store.donateForm.billingCountry =
            event.paymentMethod.billing_details.address.country;
        }

        this.props.trackPayButtonClick({
          button_type: 'Payment Request Button',
        });

        if (!this.props.validateForm()) {
          store.donateForm.disableFormSubmit = false;
          event.complete('fail');
          return false;
        }

        this.handlePayment(event);
      });
      this.paymentRequest.on('cancel', (_event) => {
        window.location.reload();
      });
    };

    handlePayment = (event) => {
      if (store.donateForm.managementMode) {
        store.donateForm.createSetupIntent(() => {
          this.props.stripe
            .confirmCardSetup(store.donateForm.setupIntentSecret, {
              payment_method: event.paymentMethod.id,
            })
            .then(
              (response) => {
                if (response.error) {
                  store.donateForm.handlePaymentRequestError(
                    response.error.message
                  );
                  event.complete('fail');
                } else {
                  store.donateForm.createDonationForm(
                    'stripe',
                    ({ redirectUrl }) => {
                      this.handlePaymentSuccess(event, redirectUrl);
                    }
                  );
                }
              },
              ({ error }) => {
                store.donateForm.handlePaymentRequestError(error);
              }
            );
        });
      } else {
        store.donateForm.paymentMethodId = event.paymentMethod.id;

        store.donateForm.processStripeDonation(
          ({ redirectUrl }) => this.handlePaymentSuccess(event, redirectUrl),
          (responseJSON) => this.handlePaymentError(event, responseJSON)
        );
      }
    };

    handlePaymentSuccess = (event, redirectUrl) => {
      try {
        event.complete('success');
      } catch (error) {
        // the Apple Pay API is known to throw an error that has no actual affect
        // on the donation process but we're catching it here so the user is
        // still redirected when this error is raised.
        if (error.name !== 'InvalidAccessError') throw error;
      } finally {
        window.location = redirectUrl;
      }
    };

    handlePaymentError = (event, responseJSON) => {
      if (responseJSON.isSpringMember) {
        store.donateForm.isAlreadySpringMember = true;
        store.donateForm.existingMembershipCountry =
          responseJSON.existingMembershipCountry;
      } else {
        store.donateForm.handlePaymentRequestError(responseJSON.error);
      }
      event.complete('fail');
    };

    buttonText = () =>
      store.donateForm.isSubscription
        ? `charity: water ${store.donateForm.isAnnual ? 'Annually' : 'Monthly'}`
        : 'charity: water';

    handleClick = () => {
      if (store.donateForm.disableFormSubmit) return;
      store.donateForm.disableFormSubmit = true;

      this.addPaymentRequestListeners();
      store.donateForm.selectedStripePaymentMethodCard = undefined;
      this.paymentRequest.show();
    };

    render() {
      return store.donateForm.supportsPaymentRequestButton ? (
        <>
          {store.donateForm.isCalmMode &&
            store.donateForm.supportsPaymentRequestButton && (
              <div className='calm-label uppercase font-medium mt-2'>
                Express payment method
              </div>
            )}
          <a
            className={cx(
              'express-donate-button button button--cw-black w-full mb-1 mt-2 text-center flex justify-center items-center',
              {
                'apple-pay-button apple-pay-button-black':
                  store.donateForm.supportsApplePay,
                disabled: store.donateForm.disableFormSubmit,
              }
            )}
            onClick={this.handleClick}
          >
            {store.donateForm.supportsApplePay ? (
              ''
            ) : (
              <>
                Express Donate
                <span className='cw-icon-double-angle-right pl-1 pt-0 sm-text-lg md-text-xl' />
              </>
            )}
          </a>
          {store.donateForm.paymentRequestButtonError && (
            <small className='leading-normal error text-cw-red text-center my-1'>
              {store.donateForm.paymentRequestButtonError}
            </small>
          )}
          {store.donateForm.isCalmMode ? (
            <div className='calm-form-explainer'>
              or enter your details manually below
            </div>
          ) : (
            <div className='text-separator relative z-10 -mb-1'>
              <span className='text-small'>
                or enter your details manually below
              </span>
            </div>
          )}
        </>
      ) : null;
    }
  }
);

export default PaymentRequestForm;
